import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService_yerbis';
import formHelper from '../../utility/formHelper';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  loginPasswordTime,
  loginPasswordTimeRes,
} = actions;

const loginEDevlet = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const temp = await formHelper.formSubmit(
        `${process.env.REACT_APP_EDEVLET_LOGIN_ENDPOINT}`,
        {
          userIdStr: values.kullaniciIdStr,
          muhendisMi: values.muhendisMi,
        },
        'post',
        true,
      );

      console.log('EDevlet Login Response:', temp);
      const response = {
        data: temp.responseData,
      };

      if (!response.data.isSuccess) {
        dispatch(loginPasswordTime(response.data.model));
        dispatch(loginErr(response.data.errorMessages));
      } else {
        localStorage.setItem('access_token', response.data.model.token);
        localStorage.setItem('refreshToken', response.data.model.refreshToken);
        localStorage.setItem('logedIn', true);
        localStorage.setItem('user', JSON.stringify(response.data.model));

        const domainList = await DataService.post('/Api/List/GetDomainList', {
          limit: 50,
          orderColumnAndDirection: '1 asc',
        });

        localStorage.setItem('domainList', JSON.stringify(domainList.data.model));

        const calismaTurList = await DataService.get('/Calisma/JeofizikCalismaTurleriListesi');

        localStorage.setItem('calismaTurList', JSON.stringify(calismaTurList.data));

        const solid = await DataService.get('/Api/GetSoilTypeDdList');

        localStorage.setItem('solidList', JSON.stringify(solid.data.model));

        dispatch(loginSuccess(true, response.data.model));
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const temp = await formHelper.formSubmit(
        '/Authorazation/Login',
        {
          username: values.username,
          password: values.password,
          bakanlikKullanicisiMi: values.bakanlikKullanicisiMi,
          recaptchaByPass: true,
        },
        'post',
        true,
      );

      const response = {
        data: temp.responseData,
      };

      if (!response.data.isSuccess) {
        dispatch(loginPasswordTime(response.data.model));
        dispatch(loginErr(response.data.errorMessages));
      } else {
        localStorage.setItem('access_token', response.data.model.token);
        localStorage.setItem('refreshToken', response.data.model.refreshToken);
        localStorage.setItem('logedIn', true);
        localStorage.setItem('user', JSON.stringify(response.data.model));

        const domainList = await DataService.post('/Api/List/GetDomainList', {
          limit: 50,
          orderColumnAndDirection: '1 asc',
        });

        localStorage.setItem('domainList', JSON.stringify(domainList.data.model));

        const calismaTurList = await DataService.get('/Calisma/JeofizikCalismaTurleriListesi');

        localStorage.setItem('calismaTurList', JSON.stringify(calismaTurList.data));

        const solid = await DataService.get('/Api/GetSoilTypeDdList');

        localStorage.setItem('solidList', JSON.stringify(solid.data.model));

        dispatch(loginSuccess(true, response.data.model));
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const loginAdmin = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const temp = await formHelper.formSubmit(
        '/EdevletLogin/Login',
        {
          userIdStr: values.userIdStr,
          muhendisMi: values.muhendisMi,
        },
        'post',
        true,
      );
      const response = {
        data: temp.responseData,
      };

      if (!response.data.isSuccess) {
        dispatch(loginPasswordTime(response.data.model));
        dispatch(loginErr(response.data.errorMessages));
      } else {
        await dispatch(logoutSuccess(true, response.data.model, true));
        await DataService.post('/Authorazation/Logout');
        // Cookies.remove('logedIn');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('girisUserList');

        localStorage.setItem('user', JSON.stringify(response.data.model));
        localStorage.setItem('access_token', response.data.model.token);
        localStorage.setItem('refreshToken', response.data.model.refreshToken);

        const domainList = await DataService.post('/Api/List/GetDomainList', {
          limit: 50,
          orderColumnAndDirection: '1 asc',
        });
        localStorage.setItem('domainList', JSON.stringify(domainList.data.model));

        const calismaTurList = await DataService.get('/Calisma/JeofizikCalismaTurleriListesi');

        localStorage.setItem('calismaTurList', JSON.stringify(calismaTurList.data));

        const solid = await DataService.get('/Api/GetSoilTypeDdList');

        localStorage.setItem('solidList', JSON.stringify(solid.data.model));

        await dispatch(loginSuccess(true, response.data.model));
        // Cookies.set('logedIn', true);
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const loginMultiUser = (values, callback) => {
  return async (dispatch) => {
    await dispatch(loginBegin());
    try {
      const temp = await formHelper.formSubmit(
        '/EdevletLogin/Login',
        {
          userIdStr: values.kullaniciIdStr,
          muhendisMi: values.muhendisMi,
        },
        'post',
        true,
      );
      const response = {
        data: temp.responseData,
      };

      if (!response.data.isSuccess) {
        dispatch(loginPasswordTime(response.data.model));
        dispatch(loginErr(response.data.errorMessages));
      } else {
        await dispatch(logoutSuccess(true, response.data.model, true));
        await DataService.post('/Authorazation/Logout');
        // Cookies.remove('logedIn');

        localStorage.removeItem('access_token');
        localStorage.removeItem('refreshToken');

        localStorage.setItem('user', JSON.stringify(response.data.model));
        localStorage.setItem('access_token', response.data.model.token);
        localStorage.setItem('refreshToken', response.data.model.refreshToken);

        const domainList = await DataService.post('/Api/List/GetDomainList', {
          limit: 50,
          orderColumnAndDirection: '1 asc',
        });
        localStorage.setItem('domainList', JSON.stringify(domainList.data.model));

        const calismaTurList = await DataService.get('/Calisma/JeofizikCalismaTurleriListesi');
        localStorage.setItem('calismaTurList', JSON.stringify(calismaTurList.data));

        const solid = await DataService.get('/Api/GetSoilTypeDdList');

        localStorage.setItem('solidList', JSON.stringify(solid.data.model));

        await dispatch(loginSuccess(true, response.data.model));
        // Cookies.set('logedIn', true);
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const loginPasswordTimeRest = () => {
  return async (dispatch) => {
    dispatch(loginPasswordTimeRes());
  };
};

const fbLogin = (callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      localStorage.setItem('logedIn', true);
      dispatch(loginSuccess(true));
      callback();
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/register', values);
      if (response.data.errors) {
        dispatch(loginErr('Registration failed!'));
      } else {
        dispatch(loginSuccess(false, null));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      await DataService.post('/Authorazation/Logout');
      localStorage.clear();
      dispatch(logoutSuccess(false, null, false));
      if (callback && typeof callback === 'function') {
        callback();
      }
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, register, fbLogin, loginPasswordTimeRest, loginAdmin, loginEDevlet, loginMultiUser };
